
import axios from '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../Style/VerifyEmailPage.css'; // Assuming you have some styles for this component
 
const VerifyEmailPage = () => {
  const { uidb64, token } = useParams();
  const [status, setStatus] = useState('idle'); // 'idle', 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
 
  const handleVerify = async () => {
    setStatus('verifying');
    setMessage('');
 
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/verify/`,
        {
          uidb64,
          token,
        }
      );
 
      setMessage(response.data.message || 'Email verified successfully.');
      setStatus('success');
 
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setMessage(
        error.response?.data?.error ||
        'Verification failed. The link may be invalid or expired.'
      );
      setStatus('error');
    }
  };
 
  return (
    <div className="verify-email-container">
      <div className="verify-box">
        {status === 'idle' && (
          <>
            <h2>Verify Your Email</h2>
            <p>Click the button below to verify your email address.</p>
            <button onClick={handleVerify} className="verify-button">
              Verify Email
            </button>
          </>
        )}
        {status === 'verifying' && <p>Verifying your email...</p>}
        {status === 'success' && (
          <div className="success-message">
            <h2>Success</h2>
            <p>{message}</p>
            <p>Redirecting to login...</p>
          </div>
        )}
        {status === 'error' && (
          <div className="error-message">
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <button onClick={handleVerify} className="verify-button">
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
 
export default VerifyEmailPage;
 